import React, {
  Children,
  useMemo,
  isValidElement,
  cloneElement,
  type CSSProperties,
  type FC,
  type PropsWithChildren,
} from 'react'
import clsx from 'clsx'
import type {RowProps} from '../Row'
import type {TableType} from '../types'
import styles from './Table.scss'


export type TableProps = {
  type?: TableType
  gap?: number
  className?: string
} & PropsWithChildren

export const Table: FC<TableProps> = (props) => {
  const {children, className, gap, type = 'admin'} = props

  const childrens = useMemo(() => Children.map(children, (child) => {
      if (!isValidElement<RowProps>(child)) return child;

      return cloneElement(child, {
        ...child.props,
        type,
      });
    }), [children]);

  const style: CSSProperties = {}
  if (gap !== undefined) {
    style['gap'] = gap
  }

  return (
    <div
      className={clsx(
        styles.wrap,
        styles[`wrap__${type}`],
        className,
      )}
      style={{gap}}
    >
        {childrens}
    </div>
  )
}
